module.exports = __webpack_public_path__ + "img/logo.7cb1b78d.png";